import qs from 'qs'
import { getCookie, delCookie } from '@/util/methods'
import { getAuthTokenCookieName } from '@/util/hanatourToken'
import { api, auth, hntDomain } from '~/config'

export default {
  namespaced: false,
  state: () => ({
    isLogged: null,
    loggedUser: null,
    serverFndAuthCookie: '',
  }),
  getters: {
    isLogged: (state) => state.isLogged,
    loggedUser: (state) => state.loggedUser,
    isUnintergratedMember: (state) =>
      state.loggedUser ? state.loggedUser.ummCnvrYn !== 'Y' : true,
  },
  actions: {
    login({ commit }, loginData) {
      return this.$http({
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        method: 'post',
        url: '/user/oauth/token',
        auth: auth,
        data: qs.stringify({
          grant_type: 'password',
          scope: 'mohajiplatform',
          ...loginData,
        }),
      }).then(({ data }) => {
        commit('setAuthenticated', true)
        commit('saveToken', data)
        return data
      })
    },
    loginSocial({ commit, dispatch }, socialCode) {
      return this.$http({
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        url: '/user/oauth/token',
        auth: auth,
        data: qs.stringify({
          code: socialCode,
          grant_type: 'authorization_code',
          scope: 'mohajiplatform',
        }),
      }).then(({ data }) => {
        commit('setAuthenticated', true)
        commit('saveToken', data)
        dispatch('getUserData', data.accessToken)
        return data
      })
    },
    refreshAuth({ commit, dispatch }, refreshToken) {
      return this.$http({
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        url: '/user/oauth/token',
        auth: auth,
        data: qs.stringify({
          refresh_token: refreshToken,
          grant_type: 'refresh_token',
          scope: 'mohajiplatform',
        }),
      })
        .then(({ data }) => {
          commit('setAuthenticated', true)
          commit('saveToken', data)
          return data
        })
        .catch((error) => {
          throw error
        })
    },
    getUserData({ commit }, data) {
      commit('setAuthenticated', true)
      if (!data) {
        this.$http.get('/user/v1/me/profile').then(({ data }) => {
          commit('setUserData', data)
          return data
        })
      } else {
        commit('setUserData', data)
      }
    },
    setAuth({ commit }, status) {
      commit('setAuthenticated', status)
    },
    editMeProfile({ commit, dispatch }, params) {
      this.$http
        .post('/user/v1/me/profile', params)
        .then(() => {
          return dispatch('getUserData')
        })
        .catch((error) => {
          return error
        })
    },
    // TODO: 기존 로그아웃 사용하는 화면 검색 후 삭제 예정
    logout({ commit }, context) {
      const { xAuthTokenName, xAuthRefreshTokenName } = getAuthTokenCookieName()

      commit('setAuthenticated', false)
      commit('setUserData', null)
      commit('SET_CUSTOMER_INFO', {
        customerId: null,
        customerNumber: null,
      })

      if (context && context.isServer) {
        const res = context.res

        res.clearCookie('auth', { domain: hntDomain })
        res.clearCookie('autoSave')
        res.clearCookie(xAuthTokenName, { domain: hntDomain })
        res.clearCookie(xAuthRefreshTokenName, { domain: hntDomain })
        res.clearCookie('hnt_uid', { domain: hntDomain })
      } else {
        delCookie('auth', hntDomain)
        delCookie('autoSave')
        delCookie(xAuthTokenName, hntDomain)
        delCookie(xAuthRefreshTokenName, hntDomain)
        delCookie('hnt_uid', hntDomain)
      }

      this.$http.defaults.cookies = null
    },
    serverLogOut({ commit }) {
      commit('setAuthenticated', false)
      commit('setUserData', null)
      commit('SET_CUSTOMER_INFO', {
        customerId: null,
        customerNumber: null,
      })
      this.$http.defaults.cookies = null
    },
    getCount({ commit }, type) {
      // cart / alert
      this.$http.get(`/user/v1/me/${type}`).then((response) => {
        if (response.status === 200 && response.data) {
          commit('setUserData', response.data)
        }
      })
    },
    getServerFndAuthCookie({ state }) {
      return state.serverFndAuthCookie || null
    },
  },
  mutations: {
    saveToken(state, data) {
      const expires = data['expires_in'] * 1000 + Date.now()
      const authString = JSON.stringify({
        accessToken: data['access_token'],
        refreshToken: data['refresh_token'],
        tokenExpired: expires,
      })
      document.cookie = `auth=${authString}; path=/; expires=${new Date(
        expires
      )}; domain=${hntDomain}`
    },
    setAuthenticated(state, status) {
      state.isLogged = status
    },
    setUserData(state, userData) {
      state.loggedUser = userData
        ? Object.assign({ photo: null }, state.loggedUser, userData)
        : userData
    },
    SET_SERVER_FND_AUTH_COOKIE(state, cookies) {
      // 데이터 init 부분: src/entry-server.js 209번 줄
      state.serverFndAuthCookie = cookies
    },
  },
}
